<!-- [ai-refactored-code] -->
<div class="container-box">
  <app-table-header
    (btnUpdateClick)="reloadTrigger$.next()"
    [showNewButton]="false"
    tableTitle="Gestione CEM"
  >
    <button
      (click)="openExtractDataDialog()"
      [disabled]="extractDataLoading"
      action-button
      class="btn btn-primary inline-grid items-center mr-2"
    >
      ESTRAI DATI
    </button>
    <button
      (click)="sendAllEmails()"
      action-button
      class="btn btn-secondary inline-grid items-center"
    >
      INVIA TUTTE LE EMAIL
    </button>
  </app-table-header>

  <div>
    <div class="table-container">
      <app-new-table
        [customButtons]="customButtons"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'id',
          direction: 'desc'
        }"
        [reloadTrigger$]="reloadTrigger$"
      ></app-new-table>
    </div>
  </div>
</div>
